import React from 'react';
import { SHADCN, TYPO, S, R } from '../theme';
import { useEntityAccent } from './EntityAccent';

// ── <SectionTitle> — titre de section avec filet et point d'accent entité ───
// `right` : contenu aligné à droite (actions, sélecteur…).

export default function SectionTitle({ children, right, style }) {
  const accent = useEntityAccent();
  const borderColor = accent ? `color-mix(in oklch, ${accent} 35%, ${SHADCN.border})` : SHADCN.border;
  return (
    <div style={{
      marginBottom: S[4], paddingBottom: S[2],
      borderBottom: `1px solid ${borderColor}`,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: S[3],
      ...style,
    }}>
      <div style={{ ...TYPO.h2, color: SHADCN.fg, minWidth: 0, display: 'flex', alignItems: 'center', gap: S[2] }}>
        {accent && (
          <span
            aria-hidden
            style={{ flexShrink: 0, width: 7, height: 7, borderRadius: R.pill, background: accent }}
          />
        )}
        <span style={{ minWidth: 0 }}>{children}</span>
      </div>
      {right}
    </div>
  );
}
